import { Link } from "react-router-dom";
import { ArrowRight, type LucideIcon } from "lucide-react";
import { useTilt } from "@/hooks/use-tilt";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  link: string;
}

const ServiceCard = ({ icon: Icon, title, description, link }: ServiceCardProps) => {
  const { ref, onMouseMove, onMouseLeave } = useTilt(10);

  return (
    <div ref={ref} onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} className="transition-transform duration-300 ease-out h-full">
      <Link
        to={link}
        className="group relative p-8 rounded-2xl bg-gradient-card border border-border/30 hover:border-primary/20 transition-all duration-500 block h-full"
      >
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-8 group-hover:bg-primary/20 transition-all duration-500">
          <Icon size={22} className="text-primary" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-3">{title}</h3>
        <p className="text-foreground/85 text-base leading-relaxed mb-8 font-light">{description}</p>
        <div className="flex items-center gap-2 text-primary text-sm font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0">
          Mehr erfahren <ArrowRight size={14} />
        </div>
      </Link>
    </div>
  );
};

export default ServiceCard;
